import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Link } from "react-router-dom";
import "./Helpchat.css";
import Contact from "./Contact";

const ClientSupport = () => {
  const [openCollapse, setOpenCollapse] = useState({
    open1: false,
    open2: false,
    open3: false,
    open4: false,
    open5: false,
  });

  const handleCollapseToggle = (collapseKey) => {
    setOpenCollapse((prevState) => ({
      ...Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === collapseKey ? !prevState[key] : false;
        return acc;
      }, {}),
    }));
  };

  return (
    <div className="ps-2">
      <div>
        <p style={{ color: "blue", fontWeight: "500" }}>
          Hi, we are here to help you
        </p>
        <p style={{ color: "#ff5c09" }}>Tips :</p>
        <ul style={{ fontSize: "12px" }}>
          <li>
            Update your profile, and keep it 100%. It will help house cooks to
            understand your location, languages better.
          </li>
          <li>
            Try to use application regularly, requirement will rank higher to
            get more cook’s responses.
          </li>
          <li>
            Shortlist matching house cooks and contact them before others pick
            them.
          </li>
        </ul>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open1")}
          aria-controls="example-fade-text"
          aria-expanded={openCollapse.open1}
          className="help"
        >
          Profile
        </p>
        <Collapse in={openCollapse.open1}>
          <div id="example-fade-text">
            <p style={{ fontSize: "12px" }}>
              Update your profile so that it will help cooks to understand your
              location and other info.
            </p>
            <Link
              to="/client/edit-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Update Basic Profile
            </Link>
            <Link
              to="/client/edit-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Update DP
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open2")}
          aria-controls="example-fade-text1"
          aria-expanded={openCollapse.open2}
          className="mt-3 help"
        >
          Requirement
        </p>
        <Collapse in={openCollapse.open2}>
          <div id="example-fade-text1">
            <p style={{ fontSize: "12px" }}>
              Update your requirement to get response from house cooks who are
              looking for a client. <br />
              Your requirement gets disabled every 45 days automatically, you
              can enable it.
            </p>
            <Link
              to="/client/edit-requirement"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Update Requirement
            </Link>
            <Link
              to="/client/requirement"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Enable/ Disable Requirement
            </Link>
          </div>
        </Collapse>
        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open3")}
          aria-controls="example-fade-text2"
          aria-expanded={openCollapse.open3}
          className="mt-3 help"
        >
          Plans
        </p>
        <Collapse in={openCollapse.open3}>
          <div id="example-fade-text2">
            <p style={{ fontSize: "12px" }}>
              Keep your plan active, to get more responses from relevant
              candidates. You need to buy a to view more cook profiles and can
              get assistance from our team.
            </p>
            <Link
              to="/client/plans"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Buy Plans
            </Link>
            <Link
              to="/client/plan-history"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Plan History
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open4")}
          aria-controls="example-fade-text3"
          aria-expanded={openCollapse.open4}
          className="mt-3 help"
        >
          Contact Settings
        </p>
        <Collapse in={openCollapse.open4}>
          <div id="example-fade-text3">
            <Link
              to="/client/profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              Add WhatsApp
            </Link>
            <Link
              to="/client/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Change Mobile Number
            </Link>
            <Link
              to="/client/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Change Email
            </Link>
            <Link
              to="/client/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              Contact Privacy
            </Link>
          </div>
        </Collapse>
        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open5")}
          aria-controls="example-fade-text4"
          aria-expanded={openCollapse.open5}
          className="mt-3 help"
        >
          Contact Us
        </p>
        <Collapse in={openCollapse.open5}>
          <div id="example-fade-text4">
            <Contact />
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default ClientSupport;
